import {
  Flex,
  toast,
  Card,
  Heading,
} from '@oliasoft-open-source/react-ui-library';
import { getRawBlob } from 'client/api-utils';
import { RecongnizebleFileFormats } from 'common/enums/known-data-enums';
import { useEffect, useState } from 'react';
import { ExcelRenderer, OutTable } from 'react-excel-renderer';
import { IObject } from 'common/interfaces/hierarchy-entities';
import classes from './excel.module.css';

interface ExcelViewerProps {
  dataObject: IObject;
}

const renderErrorToast = (err: any) => {
  toast({
    message: {
      type: 'Error',
      icon: true,
      content: typeof err === 'string' ? err : JSON.stringify(err),
    },
  });
};

const ExcelViewer = ({
  dataObject,
}: ExcelViewerProps) => {
  const [data, SetData] = useState({
    excelLoaded: false,
    cols: [],
    rows: [],
  });

  useEffect(() => {
    if (dataObject) {
      getRawBlob(dataObject.metadata.blobData.blobNameOriginal)
        .then(response => { 
          const url = (new File([response.data], 'file.xlsx', { type: RecongnizebleFileFormats.Excel }));
          ExcelRenderer(url, (err, result) => {
            if (err) {
              renderErrorToast(err);
            } 
            SetData({
              excelLoaded: true,
              cols: result.cols,
              rows: result.rows,
            });
          });
        }).catch(renderErrorToast);
    }
  }, [dataObject]);

  const { rows, cols, excelLoaded } = data;

  return (
    <Flex justifyContent="center">
      <div style={{ maxHeight: '85vh', overflow: 'auto' }}>
        <Card
          heading={<Heading>{dataObject.name}</Heading>}
          padding={false}
        >
          <div style={{ maxHeight: '80vh', overflow: 'auto' }}>
            {excelLoaded && <OutTable data={rows} columns={cols} tableClassName={classes.excelTable} tableHeaderRowClass={classes.headings} />}
          </div>
        </Card>
      </div>
    </Flex>
  );
};

export { ExcelViewer };
